import { useRunMetadataTransport } from "@/runs"

export function RunBreadcrumbContent({ runId }: { runId: string }) {
  const { data } = useRunMetadataTransport(runId, { enabled: !!runId })

  const displayName = data?.run?.display_name?.trim() || runId

  return <span>{displayName}</span>
}
